(function () {
  'use strict';

  const VIRTUALIZED_FLAG = 'data-sort-sold-out-virtualized';
  const CACHE_PREFIX = 'sos:';

  function getGrid() {
    return document.querySelector('#product-grid[data-sort-sold-out]:not([' + VIRTUALIZED_FLAG + '])');
  }

  function buildCacheKey(pathname, params) {
    const clean = new URLSearchParams(params);
    clean.delete('page');
    clean.delete('section_id');
    const entries = Array.from(clean.entries()).sort(function (a, b) { return a[0].localeCompare(b[0]); });
    return CACHE_PREFIX + pathname + '?' + entries.map(function (e) { return e[0] + '=' + e[1]; }).join('&');
  }

  function readCache(key) {
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) { return null; }
  }

  function writeCache(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* quota */ }
  }

  async function fetchPageCards(pathname, params, page) {
    const fetchParams = new URLSearchParams(params);
    fetchParams.set('page', String(page));
    const res = await fetch(pathname + '?' + fetchParams.toString(), { headers: { 'Accept': 'text/html' } });
    if (!res.ok) throw new Error('fetch failed for page ' + page);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelectorAll('#product-grid > .grid__item');
    return Array.from(items).map(function (li) {
      return {
        available: li.getAttribute('data-product-available') === 'true',
        html: li.outerHTML,
      };
    });
  }

  async function virtualize(grid) {
    grid.setAttribute(VIRTUALIZED_FLAG, 'true');

    const sectionId = grid.getAttribute('data-section-id');
    const perPage = parseInt(grid.getAttribute('data-paginate-by'), 10);
    const currentPage = parseInt(grid.getAttribute('data-current-page'), 10);
    const totalPages = parseInt(grid.getAttribute('data-total-pages'), 10);

    if (!sectionId || !perPage || !currentPage || !totalPages || totalPages <= 1) return;

    const url = new URL(window.location.href);
    const pathname = url.pathname;
    const params = new URLSearchParams(url.search);
    params.delete('page');
    params.set('section_id', sectionId);

    const cacheKey = buildCacheKey(pathname, params);
    let allCards = readCache(cacheKey);

    if (!allCards) {
      try {
        const fetches = [];
        for (let p = 1; p <= totalPages; p++) {
          fetches.push(fetchPageCards(pathname, params, p));
        }
        const pages = await Promise.all(fetches);
        allCards = pages.flat();
        writeCache(cacheKey, allCards);
      } catch (err) {
        console.warn('[sold-out-sort] virtualization aborted:', err);
        return;
      }
    }

    if (!allCards.length) return;

    const available = allCards.filter(function (c) { return c.available; });
    const soldOut = allCards.filter(function (c) { return !c.available; });
    const sorted = available.concat(soldOut);

    const start = (currentPage - 1) * perPage;
    const slice = sorted.slice(start, start + perPage);
    if (!slice.length) return;

    grid.innerHTML = slice.map(function (c) { return c.html; }).join('');
  }

  function tryVirtualize() {
    const grid = getGrid();
    if (grid) virtualize(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryVirtualize);
  } else {
    tryVirtualize();
  }

  const observer = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        tryVirtualize();
        return;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
